// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"168":"67f06b8e27402c34d8f6","590":"ad762350a2b85195612c"}[chunkId] + ".css";
};